import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { API_ROUTES } from "../../constants/apiRoutes";

const UpdatePassword = () => {
  const {  logout, userRole, id } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("jwtToken");

    try {
      await axios.post(
        userRole === "Admin"
          ? `${API_ROUTES}Account/adminupdatepassword`
          : `${API_ROUTES}Account/updatepassword`,
        userRole === "Admin"
          ? { userId: id, newPassword: newPassword }
          : { currentPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage("Password updated successfully!");
      setTimeout(() => {
        // Clear local storage and redirect to login
        logout();
      }, 2000); // Wait 2 seconds before redirecting
    } catch (error) {
      setMessage(
        "Error updating password: " + error.response?.data?.message ||
          "An unknown error occurred."
      );
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-base-200">
      <div className="w-full max-w-md p-8 space-y-3  shadow-xl rounded-lg">
        <h2 className="text-2xl font-bold text-center">Update Password</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="form-control">
            <label className="label" htmlFor="currentPassword">
              <span className="label-text">Current Password</span>
            </label>
            <input
              type="password"
              id="currentPassword"
              className="input input-bordered"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-control">
            <label className="label" htmlFor="newPassword">
              <span className="label-text">New Password</span>
            </label>
            <input
              type="password"
              id="newPassword"
              className="input input-bordered"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-control flex gap-4">
            <button type="submit" className="btn btn-primary w-full">
              Update Password
            </button>
            <button
              type="button"
              className="btn btn-secondary w-full"
              onClick={() => navigate(-1)} // Navigate back to the previous page
            >
              Back
            </button>
          </div>
        </form>
        {message && <p className="text-center mt-4">{message}</p>}
      </div>
    </div>
  );
};

export default UpdatePassword;
